/**
 * Adzuki. My Settings - Multifactor Authentication panel
 *
 * SET-26, with SET-79 (persistence), SET-80 (the authenticator setup) and SET-81 (the primary
 * method dropdown).
 *
 * THREE RULES DECIDED BEFORE ANY OF THIS WAS WRITTEN, and every one of them is a deliberate
 * divergence from the legacy screen's JS:
 *
 *   S40  a failing dependency never unchecks a method. Production's blur handler unchecks SMS
 *        and fires change the moment a phone number stops matching, so an advisor editing their
 *        number loses the selection AND, through the cascade, their primary - two choices gone
 *        to one keystroke in an unrelated field. Here the card blocks and keeps its checkbox.
 *
 *   S50  the primary options are built from the CHECKED boxes irrespective of blocked state.
 *        Production filters to checked-and-not-disabled, which would drop a blocked-but-checked
 *        method out of the dropdown and empty the advisor's primary - the same silent loss S40
 *        exists to prevent, arriving one field over.
 *
 *   S52  the reason line names two ways forward, so both have to exist. The checkbox stays
 *        disabled, which is honest - SMS cannot be ENABLED without a valid number - and the
 *        "turn it off" clause in the reason is the control that switches it off.
 *
 * AND ONE KEPT FROM PRODUCTION, ON PURPOSE: the Authenticator App box is checked ONLY by a
 * successful verification. Opening the setup leaves it unchecked, so cancelling or failing needs
 * no cleanup - there is no optimistic state to undo.
 *
 * BINDS FROM document, NOT AT READY. The modal replaces its panel on every render, so anything
 * cached or bound at $(document).ready reaches markup that was never in this document.
 */

(function MySettingsMfa($, Adzuki)
{
	"use strict";

	// the same expression the server applies to StringComponent::formatInternationalPhoneNumber()
	// output in AgentsConfirmMFADetailsForm::load(). Two copies of one rule, which S24 allows only
	// because the client is mirroring a server rule rather than inventing one.
	var PHONE_RE = /^\+\d{1,3} \d{3}-\d{3}-\d{4}$/;

	// TWO HALVES, BECAUSE THE SECOND ONE IS A CONTROL. S52's "turn it off" is a button inside
	// the sentence, and it is only offered when there is something to turn off - an unchecked
	// SMS card reads as the first half and a full stop.
	var SMS_REASON = 'Add a valid Cell Phone above to use SMS';

	var EMPTY_OPTION = 'Select a MFA method',
	    NONE_OPTION  = 'Enable a method above';

	var mfa = {},
	    secret_requested = false;

	var _panel,
	    _cards,
	    _checkbox,
	    _phoneValid,
	    _blockReasonFor,
	    _paintCard,
	    _paintAll,
	    _primarySelect,
	    _rebuildPrimary,
	    _setup,
	    _openSetup,
	    _closeSetup,
	    _fetchSecret,
	    _verify,
	    _init;

	_panel = function panel()
	{
		return $('.my-settings-overlay').find('form[data-form-component]').first();
	};

	_cards = function cards()
	{
		return _panel().find('.my-settings-mfa-card');
	};

	_checkbox = function checkbox($card)
	{
		return $card.find('.primary-mfa-method-checkbox').first();
	};

	_phoneValid = function phoneValid()
	{
		var $phone = _panel().find('.international-phone-number').first();

		if ($phone.length === 0) {
			return true;
		}

		return PHONE_RE.test($.trim($phone.val() || ''));
	};

	/**
	 * Why this method cannot be enabled, or null when it can.
	 *
	 * TWO SOURCES, AND THE SERVER'S WINS. data-mfa-block carries a reason only the server can
	 * know - the Authenticator App has no access token, or the call that reads this advisor's
	 * Cognito record failed. SMS's depends on a field the advisor is editing right now, so it
	 * is the one reason derived here.
	 */
	_blockReasonFor = function blockReasonFor($card)
	{
		var declared = $.trim($card.attr('data-mfa-block') || '');

		if (declared !== '') {
			return declared;
		}

		if ($card.attr('data-mfa-method') === 'sms' && !_phoneValid()) {
			return SMS_REASON;
		}

		return null;
	};

	/**
	 * One card's three states. The reason line occupies the same slot in all three and only its
	 * text appears or disappears, so the card never changes shape as it blocks.
	 */
	_paintCard = function paintCard($card)
	{
		var $box      = _checkbox($card),
		    reason    = _blockReasonFor($card),
		    $reason   = $card.find('.my-settings-mfa-reason'),
		    $text     = $card.find('.my-settings-mfa-reason-text'),
		    $turn_off,
		    $tail;

		$card.toggleClass('is-checked', $box.prop('checked'));
		$card.toggleClass('is-blocked', reason !== null);

		if (reason === null) {
			$box.prop('disabled', false);
			$reason.prop('hidden', true);

			return;
		}

		// S40: THE CHECKBOX KEEPS ITS VALUE. Disabled says "you cannot turn this on"; it does not
		// say "and I have turned it off for you".
		//
		// ONLY WHILE IT IS UNCHECKED, AND THAT DISTINCTION IS THE WHOLE OF SET-26's QA FAILURE.
		// A DISABLED CHECKBOX IS NOT SERIALISED. Disabling a box the advisor has CHECKED leaves the
		// tick on screen and drops the value from the payload, so the save sees one method where the
		// advisor sees two. Both symptoms QA reported come from that single fact: the count rule
		// answered with "You must enable at least two MFA methods", and the SMS block reason in
		// AgentsConfirmMFADetailsForm::validate() could not fire at all, because in_array('sms', ...)
		// was false. The server's answer was written for a payload this panel could never send.
		//
		// BLOCKED AND UNCHECKED STILL DISABLES - that is the case the block exists for. It stops SMS
		// being turned ON against an unusable number, and an unchecked box posts nothing either way.
		//
		// BLOCKED AND CHECKED STAYS ENABLED, so the selection reaches the server and the server
		// refuses the save naming both ways forward (S52). The enabled box is itself one of them, so
		// it agrees with the "turn it off" control beside it rather than competing with it - and an
		// advisor who unticks it lands in the branch above, which disables it again.
		//
		// The same trap MySettingsPanesElement records one level up: a pane is hidden by class and
		// never by `disabled`, for exactly this reason.
		$box.prop('disabled', !$box.prop('checked'));

		// S52: the second way forward, rebuilt each time so the sentence and its control cannot
		// disagree. Offered only for the reason this module derives - a server-declared block is
		// a whole sentence and names no action.
		$card.find('.my-settings-mfa-turn-off, .my-settings-mfa-reason-tail').remove();

		if (reason === SMS_REASON && $box.prop('checked')) {
			$text.text(reason + ', or ');

			$turn_off = $('<button/>', {
				type : 'button',
				class: 'my-settings-link-button my-settings-mfa-turn-off',
				text : 'turn it off'
			});

			$tail = $('<span/>', {
				class: 'my-settings-mfa-reason-tail',
				text : '.'
			});

			$text.after($turn_off, $tail);
		} else if (reason === SMS_REASON) {
			$text.text(reason + '.');
		} else {
			$text.text(reason);
		}

		$reason.prop('hidden', false);
	};

	_paintAll = function paintAll()
	{
		_cards().each(function eachCard() {
			_paintCard($(this));
		});

		_rebuildPrimary();
	};

	_primarySelect = function primarySelect()
	{
		return _panel().find('.my-settings-mfa-primary select').first();
	};

	/**
	 * SET-81's three rules, and S50's option source.
	 *
	 *   1. exactly one method enabled  -> auto-select it
	 *   2. more than one               -> keep the advisor's choice if it is still among them
	 *   3. their choice is gone, or none was made -> leave it empty and let them pick
	 *
	 * Production clears the selection whenever two or more are enabled, so an advisor who adds a
	 * backup method loses a primary they had deliberately chosen. Rule 2 is the divergence.
	 */
	_rebuildPrimary = function rebuildPrimary()
	{
		var $select = _primarySelect(),
		    current,
		    chosen      = [],
		    html        = '',
		    placeholder = '',
		    i;

		if ($select.length === 0) {
			return;
		}

		current = $select.val();

		// S50: checked, blocked or not. A blocked method is unsaveable anyway - its own reason
		// stops the save and names both ways out - so dropping it here would only replace a clear
		// message with a misleading one about a missing primary.
		_cards().each(function eachCard() {
			var $box = _checkbox($(this));

			if ($box.prop('checked')) {
				chosen.push({
					value: $box.val(),
					label: $box.data('label')
				});
			}
		});

		html += '<option value=""></option>';

		for (i = 0; i < chosen.length; i++) {
			html += '<option value="' + chosen[i].value + '"></option>';
		}

		$select.html(html);

		// text() rather than building it into the html above, so a label can never be markup.
		// The placeholder says which of the two empty states this is: nothing enabled yet, or
		// methods enabled and no primary chosen.
		placeholder = (chosen.length === 0 ? NONE_OPTION : EMPTY_OPTION);

		$select.find('option').each(function eachOption(index) {
			$(this).text(index === 0 ? placeholder : chosen[index - 1].label);
		});

		$select.prop('disabled', chosen.length === 0);

		if (chosen.length === 1) {
			$select.val(chosen[0].value);

			return;
		}

		// rule 2, then rule 3 by falling through to the empty option
		$select.val('');

		for (i = 0; i < chosen.length; i++) {
			if (chosen[i].value === current) {
				$select.val(current);

				return;
			}
		}
	};

	_setup = function setup()
	{
		return _panel().find('.my-settings-mfa-setup').first();
	};

	/**
	 * SET-80: expands the setup and asks for a secret, once.
	 *
	 * THE BOX IS NOT CHECKED HERE and is not unchecked later either - the click is prevented, so
	 * it never changed. Only a successful verification checks it.
	 */
	_openSetup = function openSetup()
	{
		var $setup = _setup();

		if ($setup.length === 0) {
			return;
		}

		$setup.prop('hidden', false);
		$setup.closest('.my-settings-mfa-card').addClass('is-expanded');

		if (secret_requested) {
			return;
		}

		secret_requested = true;

		_fetchSecret();
	};

	/**
	 * SET-80: the way out, and the only one - there is no Close button by design (S41 decision 1).
	 *
	 * COLLAPSING IS NOT A CANCEL AND NEEDS NO CLEANUP. The checkbox was never checked, so there is
	 * nothing to revert; the secret already minted is kept, because secret_requested guards the
	 * fetch and re-opening must not mint a second one behind the advisor's back.
	 */
	_closeSetup = function closeSetup()
	{
		var $setup = _setup();

		if ($setup.length === 0) {
			return;
		}

		$setup.prop('hidden', true);
		$setup.closest('.my-settings-mfa-card').removeClass('is-expanded');
	};

	/**
	 * The Cognito round trip, on demand rather than on render.
	 *
	 * Production mints a secret in the form's load(), for every unenrolled advisor on every render
	 * of the screen, and hides a failure of it by quietly disabling the checkbox. Here the advisor
	 * has asked, so both the wait and the failure are drawn.
	 */
	_fetchSecret = function fetchSecret()
	{
		var $setup   = _setup(),
		    $loading = $setup.find('.my-settings-mfa-qr-loading'),
		    $image   = $setup.find('.my-settings-mfa-qr-image'),
		    $failed  = $setup.find('.my-settings-mfa-qr-failed');

		$loading.prop('hidden', false);
		$image.prop('hidden', true);
		$failed.prop('hidden', true);

		$.getJSON(Adzuki.base_uri + '/MySettings/mfaSecret')
			.done(function got(response) {
				if (!response || response.success !== true) {
					secret_requested = false;

					$loading.prop('hidden', true);
					$failed.text((response && response.message) ? response.message : 'We could not set up your authenticator app just now. Please try again in a moment.').prop('hidden', false);

					return;
				}

				$setup.find('.my-settings-mfa-secret').text(response.secret_code);

				$image.attr('src', response.qr_code).prop('hidden', false);
				$loading.prop('hidden', true);
			})
			.fail(function failed() {
				// ASKING AGAIN HAS TO BE POSSIBLE, so the one-shot latch is released on failure.
				// associateSoftwareToken is safe to re-run - it mints a new secret, and only the
				// one the advisor actually scans is ever verified.
				secret_requested = false;

				$loading.prop('hidden', true);
				$failed.text('We could not set up your authenticator app just now. Please try again in a moment.').prop('hidden', false);
			});
	};

	/**
	 * SET-80: verifies the code, and checks the box only if Cognito agrees.
	 *
	 * POSTED ON ITS OWN, under VerifySoftwareTokenForm's attribute map. It cannot be part of the
	 * panel's form - this markup sits inside it and HTML has no nested forms - and it should not
	 * be: verifying is not saving. The endpoint hands the payload to the same form class the
	 * legacy screen uses, so the length rule and the error mapping are shared rather than copied.
	 */
	_verify = function verify()
	{
		var $setup  = _setup(),
		    $input  = $setup.find('.my-settings-mfa-code-input'),
		    $error  = $setup.find('.my-settings-mfa-verify-error'),
		    $button = $setup.find('.my-settings-mfa-verify'),
		    payload = {
			    form_component_data: { VerifySoftwareToken: { code: $input.val() } },

			    // SET-80: FormComponent REFUSES A POST WITHOUT THIS, and the refusal names nothing
			    // the advisor or the developer can act on. _buildValidationData() throws "Missing
			    // form attribute data" before any field is read, so the code never reached Cognito,
			    // nothing appeared in the Auth Service logs, and the panel showed its generic
			    // "could not verify that code just now" - which reads as a rejected code.
			    //
			    // form.js builds this map from the inputs of a real <form> and appends it on every
			    // AJAX submit. There is no form to read here: the code input deliberately carries no
			    // name attribute, because this markup sits INSIDE the panel's form and HTML has no
			    // nested forms (see MySettingsMfaAppSetupElement). So the map is stated rather than
			    // derived, and it is one entry because the posted payload is one field.
			    //
			    // The key is the field path with the form name stripped, which is what form.js
			    // produces for form_component_data[VerifySoftwareToken][code]. The server passes the
			    // attributes through to validationData and reads none of them here; the label and the
			    // length rule come from VerifySoftwareTokenForm's own $fields.
			    form_component_attribute_data: JSON.stringify({ code: { type: 'text' } })
		    };

		$error.prop('hidden', true);
		$button.prop('disabled', true);

		$.post(Adzuki.base_uri + '/MySettings/verifySoftwareToken', payload, null, 'json')
			.done(function answered(response) {
				var message;

				$button.prop('disabled', false);

				if (response && response.status === 'success') {
					// the handshake, in production's own order: flag, then box, then collapse
					_panel().find('#verified_software_token').val('1');

					_panel().find('#totp_checkbox').prop('checked', true).trigger('change');

					_closeSetup();
					$input.val('');

					return;
				}

				message = 'We could not verify that code. Please check it and try again.';

				if (response && typeof response.data === 'string') {
					message = response.data;
				} else if (response && $.isArray(response.data) && response.data.length > 0 && response.data[0].message) {
					message = response.data[0].message;
				}

				$error.text(message).prop('hidden', false);
			})
			.fail(function failed() {
				$button.prop('disabled', false);

				$error.text('We could not verify that code just now. Please try again in a moment.').prop('hidden', false);
			});
	};

	_init = function init()
	{
		if (_cards().length === 0) {
			return;
		}

		secret_requested = false;

		_paintAll();
	};

	$(document).ready(function documentReady() {
		$(document).on('my-settings:rendered', function panelRendered() {
			_init();
		});

		// S40 LIVES HERE, IN WHAT THIS HANDLER DOES NOT DO. Production's blur handler unchecks the
		// SMS box; this one only repaints, so a number edited into an invalid state blocks the card
		// and leaves every selection exactly as the advisor left it.
		$(document).on('input change blur', '.my-settings-overlay .international-phone-number', function phoneChanged() {
			_paintAll();
		});

		$(document).on('change', '.my-settings-overlay .primary-mfa-method-checkbox', function methodToggled() {
			_paintAll();
		});

		// SET-80: the Authenticator App box opens the setup instead of checking itself
		$(document).on('click', '.my-settings-overlay #totp_checkbox', function totpClicked(e) {
			var $box = $(this);

			if (!$box.prop('checked')) {
				return;
			}

			// already verified with Cognito, so this is an ordinary checkbox from here on
			if (_panel().find('#verified_software_token').val() === '1') {
				return;
			}

			if (_setup().length === 0) {
				return;
			}

			e.preventDefault();

			// SET-80: THE SECOND CLICK CLOSES IT. preventDefault keeps the box unchecked, so every
			// click on it reads as a checking click and the guard above never fires once the setup
			// is open - which left re-opening as the only thing a click could do, and with no Close
			// button (S41 decision 1) the advisor could not get out of the card at all. The checkbox
			// is the control that opened it, so it is the control that closes it.
			if (!_setup().prop('hidden')) {
				_closeSetup();

				return;
			}

			_openSetup();
		});

		$(document).on('click', '.my-settings-overlay .my-settings-mfa-show-secret', function showSecret(e) {
			var $secret = _setup().find('.my-settings-mfa-secret'),
			    hidden  = $secret.prop('hidden');

			e.preventDefault();

			$secret.prop('hidden', !hidden);

			$(this).text(hidden ? 'Hide secret key' : 'Show secret key');
		});

		$(document).on('click', '.my-settings-overlay .my-settings-mfa-verify', function verifyClicked(e) {
			e.preventDefault();

			_verify();
		});

		// S52: the only way to switch off a blocked method, and an ordinary uncheck once it runs -
		// so SET-81's rule 3 applies and the primary empties if this was the one chosen
		$(document).on('click', '.my-settings-overlay .my-settings-mfa-turn-off', function turnOff(e) {
			var $card = $(this).closest('.my-settings-mfa-card');

			e.preventDefault();

			_checkbox($card).prop('checked', false).trigger('change');
		});
	});

	Adzuki.MySettingsMfa = mfa;

}(jQuery, window.Adzuki || {}));
